
function validateMoneyMask(value) {
    if (/[a-zA-Z]/.test(value)) {
        return value;
    }

    if (value===0) return value;

    const formattedValue = value.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
    });
    return formattedValue;
}

export default { validateMoneyMask };
